import { helper } from '@ember/component/helper';
import { brightnessByColor as brightnessByColor$1 } from 'beebee-base/lib/utility';

const BRIGHTNESS_THRESHOLD = 75.2;
var brightnessByColor = helper(function brightnessByColorHelper([color]) {
  if (!color) return false;
  return brightnessByColor$1(color) < BRIGHTNESS_THRESHOLD;
});

export { brightnessByColor as default };
//# sourceMappingURL=brightness-by-color.js.map
